
import { defineComponent, onMounted, ref } from 'vue'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import FileDrop from '@/components/FileDrop.vue'
import ImageDisplay from '@/components/ImageDisplay.vue'
import CompanyInformation from '@/pages/NewSettings/components/CompanySettings/CompanyInformation.vue'
import CompanyAddress from '@/pages/NewSettings/components/CompanySettings/CompanyAddress.vue'
import { useStore } from 'vuex'
import ServiceType from '@/models/interfaces/service'
import { Tenant } from '@/pages/Settings/components/editors/TenantConfigEditor.vue'
import BusinessRegistrationDetails from '@/pages/NewSettings/components/CompanySettings/BusinessRegistrationDetails.vue'
import PrinterInformation from '@/pages/NewSettings/components/CompanySettings/PrinterInformation.vue'
import ShippingProviders from '@/pages/NewSettings/components/CompanySettings/ShippingProviders.vue'
import PriceFix from './PriceFix.vue'
import PricingServices from './PricingServices.vue'


export default defineComponent({
  name: 'CompanySettings',
  components: {
    PrinterInformation,
    BusinessRegistrationDetails,
    CompanyAddress,
    CompanyInformation,
    ImageDisplay,
    FileDrop,
    EditableBlockInput,
    EditableBlock,
    ShippingProviders,
    PricingServices
  },
  setup () {
    const $store = useStore()
    const $sys = $store.getters['Services/Sys']
    const tenant = ref<Tenant | null>(null)
    const printers = ref()
    const channels = ref()

    const getTenant = async () => {
      await $sys.get(`service/${ServiceType.CtrlService.Sys}/tenant`).then(result => {
        tenant.value = result.items?.[0]
      })
    }

    const saveTenant = async (event) => {
      const response = await $sys.patch('/service/ctrl/tenant', undefined, event)
    }

    const getPrinters = async () => {
      const {items} = await $sys.get('/service/printnode/config')
      printers.value = items?.[0] || {}
        if (!printers.value.configurations) printers.value.configurations = { printer: { collection: { items: [] }, items: [] }}
        const { items: printerStatus } = await $sys.get('/service/printnode/printers.status')
        printers.value.configurations.printer.items = printers.value.configurations.printer.items?.map(p => {
            return !p ? null : { ...p, status: (printerStatus?.find(s => s.id?.toString() === (p?.id || '').toString()) || {}).state }
          }).filter(Boolean) || []
    }

    const getChannels = async () => {
      const { items } = await $sys.get('/service/directr/catalogue')
      if (!items) return
      channels.value = items.map(c => ({ label: c.name, value: c.sys.id }))
    }

    const handleAddPrinter = async (event) => {
      const response = await $sys.with('/service/printnode/printer').patch(event)
      void getPrinters()
    }

    const handleUpdatePrinter = async (event, printerId) => {
      const updatedPrinter = { ...event, sys: { type: 'printer', id: printerId } }
      const response = await $sys.patch('/service/printnode/config', undefined, updatedPrinter)
      void getPrinters()
    }

    const handleRemovePrinter = async (event) => {
      const response = await $sys.with('/service/printnode/printer').delete(event.sys.id)
      void getPrinters()
    }

    onMounted(() => {
      void getTenant()
      void getPrinters()
      void getChannels()
    })

    return {
      tenant,
      printers,
      channels,
      saveTenant,
      handleAddPrinter,
      handleUpdatePrinter,
      handleRemovePrinter,
    }
  }
})
